import { getBackOfficeAPIPath } from '@treasury/core/http';

angular
    .module('backOffice')
    .factory(
        'bannerAndModalMessageConfigurationService',
        bannerAndModalMessageConfigurationService
    );

bannerAndModalMessageConfigurationService.$inject = ['$resource'];

function bannerAndModalMessageConfigurationService($resource) {
    const resourceUrl = `${getBackOfficeAPIPath()}BannerAndModalMessageConfiguration/`;

    return {
        getInstitutionProducts,
        getBannerAndModalMessageConfigurations,
        deleteMessage,
        updateBannerAndModalMessageConfiguration,
        saveBannerAndModalMessageConfiguration,
        changeStatus,
    };

    function getInstitutionProducts() {
        return $resource(`${getBackOfficeAPIPath()}InstitutionProducts`).query().$promise;
    }

    function saveBannerAndModalMessageConfiguration(bannerAndModalMessageConfiguration) {
        bannerAndModalMessageConfiguration.id = 0; // Ensure ID is 0 for new entries (API requirement)
        return $resource(resourceUrl).save(bannerAndModalMessageConfiguration).$promise;
    }

    function updateBannerAndModalMessageConfiguration(bannerAndModalMessageConfiguration) {
        const resource = $resource(
            `${resourceUrl}:id`,
            { id: bannerAndModalMessageConfiguration.id },
            { update: { method: 'PUT' } }
        );
        return resource.update(bannerAndModalMessageConfiguration).$promise;
    }

    function deleteMessage(id) {
        return $resource(`${resourceUrl}:id`, { id }).delete().$promise;
    }

    async function getBannerAndModalMessageConfigurations() {
        // API doesn't return product type descriptions, so we need to look them up
        const configPromise = $resource(resourceUrl).query().$promise;
        const [config, productLookup] = await Promise.all([
            configPromise,
            getInstitutionProducts(),
        ]);
        config.forEach(item => {
            const lookupItem = productLookup.find(n => n.productTypeId === item.productTypeId);
            item.productTypeDescription = item.productTypeId === 0 ? 'All' : lookupItem.description;
        });
        return (
            config
                // Sort by active status first, then by start date descending
                .sort((a, b) => {
                    if (a.status === b.status) {
                        return new Date(b.startDate) - new Date(a.startDate);
                    }
                    return a.status === 'Active' ? -1 : 1;
                })
        );
    }

    async function changeStatus({ id, status }) {
        return $resource(`${resourceUrl}:id/ChangeStatus/:status`, { id, status }).save().$promise;
    }
}
